// src/authConfig.js
import { LogLevel } from "@azure/msal-browser";
import { getOidcClientId } from "./services/userService";

// Function to fetch client ID from API
const fetchClientId = async () => {
  try {
    const clientId = await getOidcClientId();
    if (clientId) {
      return clientId;
    }
    throw new Error("Failed to fetch client ID from API");
  } catch (error) {
    console.error("Error fetching client ID:", error);
    console.error("Error details:", error.message);
    return "0d86f1c2-5520-4ca7-9c3c-02fab55a96d1"; // Fallback to PROD
  }
};

// Initialize config with placeholder - will be updated when client ID is fetched
export const msalConfig = {
  auth: {
    authority:
      "https://login.microsoftonline.com/3bdec65b-3f6d-43bb-a194-ad92c0909287/v2.0",
    clientId: "", // Will be populated by initializeAuth
    redirectUri: window.location.origin + "/",
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            //console.info(message);
            return;
          case LogLevel.Verbose:
            //console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            //console.info(message);
            return;
        }
      },
    },
  },
};

export const loginRequest = {
  scopes: ["User.Read"],
};

// Function to initialize authentication config with dynamic client ID
export const initializeAuth = async () => {
  const clientId = await fetchClientId();
  msalConfig.auth.clientId = clientId;
  return msalConfig;
};
